import { KYMW4500Component } from './kymw4500.component';
import { GetFeatureMasterInfoResponse } from './api-services/get-feature-master-info.service';
import { GetNotificationUserResponse } from './api-services/get-notification-user-list.service';
import { GetApprovalFlowListResponse } from './api-services/get-approval-flow-list.service';
import { GetFixFeatureForMasterInfoResponse } from './api-services/get-fix-feature-for-master-info.service';
import { GetCatalogFixFlagResponse } from './api-services/get-catalog-fix-flag.service';


/**
 * 特集マスタ画面の値を管理するクラス
 *
 * @export KYMW4500Model
 * @class KYMW4500Model
 */
export class KYMW4500Model {
  public kymw4500Component: KYMW4500Component;
  public btnImageMakeInstructionDisabled: boolean = <boolean>false;
  public btnImageAllRegistDisabled: boolean = <boolean>false;
  public pureFeatureList = []; // 変更前の特集情報
  public featureList = []; // 変更中（表示中）の特集情報
  public catalogId: string;
  public orderCode: string;
  public approvalFlowTypeList = [];
  public notificationUserList = [];
  public mediumType: string;
  public mediumGroupDiv: string;
  public isOnlyCatalogId: boolean;
  public exclusiveDatetime: string;
  public catalogFixFlag = true;

  //活性・非活性制御
  public pageEditBtnDisabled: boolean = <boolean>false;
  public fixedSpecialFeatureListBtnDisabled: boolean = <boolean>false;
  public specialFeatureCopyBtnDisabled: boolean = <boolean>false;
  public saveBtnDisabled: boolean = <boolean>false;
  public addBtnDisabled: boolean = <boolean>false;

  /**
   * 承認フロー区分セレクトリスト項目の設定
   * @param response
   */
  public setApprovalFlowList(response: GetApprovalFlowListResponse[]) {
    this.approvalFlowTypeList = response.map(_ => {
      return {
        approvalFlowType: _.ApprovalFlowType,
        approvalFlowTypeName: _.ApprovalFlowTypeName
      }
    });
  }

  /**
   * 通知受領担当一覧取得
   * @param response 
   */
  public setNotificationUserList(response: GetNotificationUserResponse[]) {
    this.notificationUserList = response.map(_ => {
      return {
        notificationUserId: _.NotificationUserId,
        notificationUserName: _.NotificationUserName
      }
    });
  }

  public setFeatureMasterInfoList(featureList: GetFeatureMasterInfoResponse) {
    this.featureList = featureList.FeatureMasterList.map(_ => {
      return {
        OrderCode: _.OrderCode,
        DelivCatalogId: _.DelivCatalogId,
        MediumType: _.MediumType,
        MediumName: _.MediumName,
        FeatureCode: _.FeatureCode,
        FeatureName: _.FeatureName,
        ApprovalFlowType: _.ApprovalFlowType,
        ApprovalFlowTypeName: _.ApprovalFlowTypeName,
        NotificationUserId: _.NotificationUserId,
        NotificationUserName: _.NotificationUserName,
        PlannerSelectionFlag: _.PlannerSelectionFlag,
        AssociatedCompanyId: _.AssociatedCompanyId,
        AssociatedCompanyName: _.AssociatedCompanyName,
        AssociatedCompanyExsist: _.AssociatedCompanyName !== '',
        Remarks: _.Remarks,
        FeaturePerMediaFlag: _.FeaturePerMediaFlag,
        TagList: _.TagList ? _.TagList : [],
        Tags: _.TagList.map(_ => _.TagName).join(', '),
        PayeeSupplierList: _.PayeeSupplierList ?_.PayeeSupplierList : [],
        PayeeSuppliers: _.PayeeSupplierList.map(_ => `${_.PayeeSupplierCode}:${_.PayeeSupplierName}`).join(', ')
      };
    });
    this.pureFeatureList = JSON.parse(JSON.stringify(this.featureList));
  }

  public setGetFixFeatureForMasterInfoList(fixFeatureList: GetFixFeatureForMasterInfoResponse[]) {
    this.featureList = fixFeatureList.map(_ => {
      return {
        OrderCode: _.OrderCode,
        DelivCatalogId: _.DelivCatalogId,
        MediumType: _.MediumType,
        MediumName: _.MediumName,
        FeatureCode: _.FeatureCode,
        FeatureName: _.FeatureName,
        ApprovalFlowType: _.ApprovalFlowType,
        ApprovalFlowTypeName: _.ApprovalFlowTypeName,
        NotificationUserId: _.NotificationUserId,
        NotificationUserName: _.NotificationUserName,
        AssociatedCompanyId: _.AssociatedCompanyId,
        AssociatedCompanyName: _.AssociatedCompanyName,
        AssociatedCompanyExsist: _.AssociatedCompanyName !== '',
        Remarks: _.Remarks,
        FeaturePerMediaFlag: _.FeaturePerMediaFlag,
        TagList: _.TagList ? _.TagList : [],
        Tags: _.TagList?.length ? _.TagList.map(_ => _.TagName).join(', ') : '',
        PlannerSelectionFlag: _.PlannerSelectionFlag,
        PayeeSupplierList: _.PayeeSupplierList ?_.PayeeSupplierList : [],
        PayeeSuppliers: _.PayeeSupplierList?.length ? _.PayeeSupplierList.map(_ => `${_.PayeeSupplierCode}:${_.PayeeSupplierName}`).join(', ') : ''
      };
    });
  }

  public setCatalogFixFlag(data: GetCatalogFixFlagResponse) {
    this.catalogFixFlag = data.CatalogFixFlag === '1';
  }
}
